import {
    Box,
    Flex,
    Text,
    Button,
    Modal,
    ModalOverlay,
    Checkbox,
    ModalContent,
    ModalHeader,
    ModalBody,
    Divider,
    FormLabel,
    Menu,
    MenuButton,
    MenuList,
    Grid,
    GridItem,
    FormControl,
} from '@chakra-ui/react';
import React, { useEffect, useState } from "react";
import Icon from "../../../components/Theme/Icon";
import IconButton from "../../../components/Theme/IconButton";
import { useListCities, useListStates } from "../../../core/hooks";
import styles from "./styles";
import { ReactComponent as DownArrow } from '../../../assets/downArrow.svg'

const ServiceableAreas = ({ isOpen, onClose, userType, serviceArea, setServiceArea }) => {
    const [areas, setAreas] = useState([]);
    const [stateNames, setStateNames] = useState([]);
    const [selectAllStatesChecked, setSelectAllStatesChecked] = useState(false);

    const { states } = useListStates(userType);
    const { cities, refetchCities } = useListCities(stateNames);

    useEffect(() => {
        if (serviceArea && serviceArea.length > 0) {
            const initializedAreas = serviceArea.map(item => ({
                ...item,
                checked: true,
                isClose: item.isClose !== undefined ? item.isClose : true
            }));
            setAreas(initializedAreas);
            setStateNames(initializedAreas);
        } else {
            setAreas([]);
            setStateNames([]);
            setSelectAllStatesChecked(false);
        }
    }, [serviceArea, isOpen]);

    useEffect(() => {
        if (states?.data?.data?.length && areas.length > 0) {
            const allChecked = areas.length === states.data.data.length && areas.every(a => a.checked);
            setSelectAllStatesChecked(allChecked);
        } else {
            setSelectAllStatesChecked(false);
        }
    }, [areas, states]);

    useEffect(() => {
        if (stateNames.length > 0) refetchCities();
    }, [stateNames]);

    useEffect(() => {
        if (!cities?.data?.data) return;

        setAreas(prevAreas =>
            prevAreas.map(item => {
                const cityListFromApi = cities.data.data[item.name];
                if (cityListFromApi) {
                    const existingCityValues = {};
                    if (item.child) {
                        item.child.forEach(c => {
                            existingCityValues[c.name] = c.value;
                        });
                    }

                    const mergedChildren = cityListFromApi.map(apiCity => ({
                        ...apiCity,
                        value: item.checkedAll ? true : (existingCityValues[apiCity.name] ?? false)
                    }));

                    return { ...item, child: mergedChildren };
                }
                return item;
            })
        );
    }, [cities]);

    const handleSelectAllStates = (e) => {
        const checked = e.target.checked;
        setSelectAllStatesChecked(checked);

        if (!checked) {
            setAreas([]);
            setStateNames([]);
            return;
        }

        if (!states?.data?.data) return;

        const allStates = states.data.data.map(item => ({
            ...item,
            checked: true,
            checkedAll: true,
            isClose: true,
            child: []
        }));

        setAreas(allStates);
        setStateNames(allStates);
    };
    const handleMenuSelection = (e, item) => {
        const isChecked = e.target.checked;

        if (isChecked) {
            setAreas(prev => {
                const exists = prev.some(a => a.name === item.name);
                if (exists) return prev;
                return [...prev, { ...item, checked: true, checkedAll: false, isClose: true, child: [] }];
            });

            setStateNames(prev => {
                const exists = prev.some(a => a.name === item.name);
                if (exists) return prev;
                return [...prev, item];
            });
        } else {
            setAreas(prev => prev.filter(v => v.name !== item.name));
            setStateNames(prev => prev.filter(v => v.name !== item.name));
        }
    };

    const handleHeaderCheckbox = (stateIndex, checked) => {
        setAreas(prev => {
            const newAreas = [...prev];
            const targetState = { ...newAreas[stateIndex] };

            targetState.checked = checked;

            if (!checked) {
                targetState.checkedAll = false;
                if (targetState.child) {
                    targetState.child = targetState.child.map(city => ({
                        ...city,
                        value: false
                    }));
                }
            }

            newAreas[stateIndex] = targetState;
            return newAreas;
        });
    };

    const handleSelectState = (stateIndex, checked) => {
        setAreas(prevAreas => {
            const newAreas = [...prevAreas];
            const targetState = { ...newAreas[stateIndex] };

            if (checked) targetState.checked = true;

            targetState.checkedAll = checked;

            if (targetState.child && targetState.child.length > 0) {
                targetState.child = targetState.child.map(city => ({
                    ...city,
                    value: checked
                }));
            }

            newAreas[stateIndex] = targetState;
            return newAreas;
        });
    };

    const handleCityChange = (stateIndex, cityIndex, checked) => {
        setAreas(prevAreas => {
            const newAreas = [...prevAreas];
            const targetState = { ...newAreas[stateIndex] };

            if (checked) targetState.checked = true;

            if (!targetState.child) return newAreas;

            const newChildren = [...targetState.child];
            newChildren[cityIndex] = { ...newChildren[cityIndex], value: checked };
            targetState.child = newChildren;

            const allChecked = newChildren.length > 0 && newChildren.every(c => c.value);
            targetState.checkedAll = allChecked;

            newAreas[stateIndex] = targetState;
            return newAreas;
        });
    };

    const toggleAccordion = (index) => {
        setAreas(prev => {
            const newAreas = [...prev];
            newAreas[index] = { ...newAreas[index], isClose: !newAreas[index].isClose };
            return newAreas;
        });
    };

    return (
        <Box>
            <Modal isCentered isOpen={isOpen} onClose={onClose}>
                <ModalOverlay />
                <ModalContent overflow="hidden" borderRadius="10px" minW="587px">
                    <ModalHeader backgroundColor="#FFE68D" height="70px" textAlign="center">
                        <Text fontWeight="700" fontSize="24px" m={0} as="h2">
                            Serviceable Areas
                        </Text>
                    </ModalHeader>

                    <IconButton
                        height="unset"
                        onClick={onClose}
                        _hover={{ bg: 'none' }}
                        _active={{ bg: 'none' }}
                        bg="none"
                        aria-label="close button"
                        position="absolute"
                        top="1.5rem"
                        right="0.75rem"
                        icon={<Icon type="darkClose" />}
                    />

                    <ModalBody overflow="scroll" maxH="600px">
                        <Flex mt={6} justifyContent="flex-end">
                            <Button
                                type="submit"
                                onClick={() => {
                                    const savedData = areas
                                        .filter(item => item.checked)
                                        .map(item => ({
                                            ...item,
                                            child: item.child ? item.child.filter(c => c.value) : []
                                        }));
                                    setServiceArea(savedData);
                                    onClose();
                                }}
                                w="135px"
                                h="40px"
                                backgroundColor="#8FCF74"
                            >
                                <Text fontWeight="700" fontSize="12px" ml={1} color="black" mt="2px">
                                    SAVE
                                </Text>
                            </Button>
                        </Flex>

                        <Text as="h2" color="#2C628D">Serviceable Areas - Counties</Text>
                        <Box minH='450px' border="1px solid" borderRadius="6px 6px 0px 0px" p="20px" borderColor="#A9A9A9">
                            <Box mb={3}>
                                <Checkbox
                                    isChecked={selectAllStatesChecked}
                                    onChange={handleSelectAllStates}
                                >
                                    Select All Counties For All States
                                </Checkbox>
                            </Box>

                            {states && (
                                <FormControl css={styles.menu}>
                                    <FormLabel fontWeight="600" fontSize="md" color="blue.200">Select Areas</FormLabel>
                                    <Menu>
                                        <MenuButton as={Flex} px={4} alignItems="center" position='relative' border="1px solid" overflow="scroll" borderColor="rgba(169, 169, 169, 0.87)" borderRadius="5px" bg="white.100" height="40px">
                                            <Box flex="1" overflow="hidden">
                                                <Text isTruncated fontSize="xl">
                                                    {areas.length > 0
                                                        ? areas.map(item => item.name).join(', ')
                                                        : 'Select States...'}
                                                </Text>
                                            </Box>
                                            <Flex position='absolute' right='15px' top='15px'><DownArrow /></Flex>
                                        </MenuButton>
                                        <MenuList pl={6} zIndex={10}>
                                            <Grid templateColumns={`repeat(3, 1fr)`}>
                                                {states?.data?.data?.map((item, index) => (
                                                    <GridItem key={index} colSpan={1}>
                                                        <Checkbox
                                                            isChecked={areas.some(a => a.name === item.name)}
                                                            onChange={(e) => handleMenuSelection(e, item)}
                                                            iconColor="black"
                                                            colorScheme="whiteAlpha"
                                                        >
                                                            {item.name}
                                                        </Checkbox>
                                                    </GridItem>
                                                ))}
                                            </Grid>
                                        </MenuList>
                                    </Menu>
                                </FormControl>
                            )}

                            {areas.map((state, stateIndex) => (
                                <Box key={`${state.name}-${stateIndex}`}>
                                    <Flex mt={5}>
                                        <Checkbox
                                            isChecked={!!state.checked}
                                            onChange={(e) => handleHeaderCheckbox(stateIndex, e.target.checked)}
                                        />
                                        <Text
                                            w='max-content'
                                            fontWeight="700"
                                            ml={1}
                                            fontSize="18px"
                                            cursor="pointer"
                                            onClick={() => toggleAccordion(stateIndex)}
                                        >
                                            {state.name}
                                        </Text>
                                        <Divider mt={3} ml={5} borderColor="#000000" border="1px solid" orientation="horizontal" />
                                    </Flex>

                                    {!state.isClose && (
                                        <Flex>
                                            <Divider mt={3} orientation="vertical" height='auto' borderColor="#000000" borderLeft="2px solid" />
                                            <Flex ml={5} mt={3} flexDirection="column" justifyContent="space-between">
                                                <Checkbox
                                                    isChecked={!!state.checkedAll}
                                                    onChange={(e) => handleSelectState(stateIndex, e.target.checked)}
                                                >
                                                    Select All Counties For {state.name}
                                                </Checkbox>

                                                {state.child && state.child.map((city, cityIndex) => (
                                                    <Checkbox
                                                        key={`${city.name}-${cityIndex}`}
                                                        value={city.name}
                                                        isChecked={!!city.value}
                                                        onChange={(e) => handleCityChange(stateIndex, cityIndex, e.target.checked)}
                                                    >
                                                        {city.name}
                                                    </Checkbox>
                                                ))}
                                            </Flex>
                                        </Flex>
                                    )}
                                </Box>
                            ))}
                        </Box>
                    </ModalBody>
                </ModalContent>
            </Modal>
        </Box>
    );
};

export default ServiceableAreas;